import React, { useEffect, useState } from "react";
import { AppBar, Button, Drawer, IconButton, MenuItem, Toolbar, Typography, Menu, ListItemIcon, ListItemText, Avatar, Grid, Divider } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuICon from "@material-ui/icons/Menu";
import { AuthUserContext } from "../Session";
import AuthDrawer from "./AuthDrawer";
import { SignOutMenuItem } from "../SignOut";
import ChangePasswordMenuItem from "./ChangePasswordMenuItem";
import LangSelect from "./LangSelect";
import OnsiteTrainingButton from "./OnsiteTrainingButton";
import { useHistory, useLocation } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import { purple } from "@material-ui/core/colors";
import { Person } from "@material-ui/icons";
import { useTranslation } from "react-i18next";

const Navigation = ({ authUser }) => {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const { t, i18n } = useTranslation();

    const [anchor, setanchor] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        authUser?.info?.defaultLang && i18n.changeLanguage(authUser.info.defaultLang);
    }, []);

    if (location.pathname === ROUTES.WAITINGFORCOMPLETEUSERACCOUNT) {
        return <></>;
    } else {
        return (
            <>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={() => setanchor(true)}>
                            <MenuICon />
                        </IconButton>

                        <Typography variant="h5" className={classes.title} style={{ cursor: "pointer", alignItems: "center" }} onClick={() => history.push(ROUTES.HOME)}>
                            Reanibex Training
                            {/*} <svg style={{ width: 32, height: 32, alignSelf: "center" }} viewBox="0 0 32 32">
                <path
                  fill="white"
                  d="M10 6.2C10 4.3 8.8 2.6 7 2V5.7H4V2C2.2 2.6 1 4.3 1 6.2C1 8.1 2.2 9.8 4 10.4V21.4C4 21.8 4.2 22 4.5 22H6.5C6.8 22 7 21.8 7 21.5V10.5C8.8 9.9 10 8.2 10 6.2M16 8C16 8 15.9 8 16 8C12.1 8.1 9 11.2 9 15C9 18.9 12.1 22 16 22S23 18.9 23 15 19.9 8 16 8M16 20C13.2 20 11 17.8 11 15S13.2 10 16 10 21 12.2 21 15 18.8 20 16 20M15 11V16L18.6 18.2L19.4 17L16.5 15.3V11H15Z"
                />
    </svg>*/}
                        </Typography>

                        <AuthUserContext.Consumer>{(authUser) => authUser && <OnsiteTrainingButton user={authUser} />}</AuthUserContext.Consumer>
                        <AuthUserContext.Consumer>
                            {(authUser) => (
                                <div>
                                    <IconButton aria-label="account of current user" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleMenu} color="inherit" size="small">
                                        <Avatar
                                            style={{
                                                height: 46,
                                                width: 46,
                                                marginTop: 9,
                                                marginBottom: 9,
                                            }}
                                        >
                                            {authUser?.displayName?.charAt(0)}
                                        </Avatar>
                                    </IconButton>
                                    <Menu
                                        id="menu-appbar"
                                        anchorEl={anchorEl}
                                        anchorOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                        keepMounted
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                        open={open}
                                        onClose={handleClose}
                                    >
                                        <Grid container alignItems="center" justify="center" direction="column" style={{ marginTop: 16, marginBottom: 8 }}>
                                            <Avatar
                                                onClick={() => {
                                                    history.push(ROUTES.PROFILE.replace(":uid", authUser.uid));
                                                    handleClose();
                                                }}
                                                className={classes.profileAvatar}
                                            >
                                                {authUser?.displayName?.charAt(0)}
                                            </Avatar>
                                            <Typography variant="body1" style={{ fontWeight: 500, fontSize: 22 }}>
                                                {authUser.displayName}
                                            </Typography>
                                            <Typography variant="body1" color="textSecondary">
                                                {authUser.email}
                                            </Typography>
                                        </Grid>
                                        <Divider />
                                        <MenuItem
                                            onClick={() => {
                                                handleClose();
                                                history.push(ROUTES.PROFILE.replace(":uid", authUser.uid));
                                            }}
                                        >
                                            <ListItemIcon>
                                                <Person color={"primary"} />
                                            </ListItemIcon>
                                            <ListItemText>{t("my_account")}</ListItemText>
                                        </MenuItem>
                                        <Divider />
                                        <LangSelect style={{ marginRight: 6 }} menu closeMenu={handleClose} />
                                        <Divider />
                                        <SignOutMenuItem />
                                        <Divider />
                                        <ChangePasswordMenuItem close={handleClose} />
                                    </Menu>
                                </div>
                            )}
                        </AuthUserContext.Consumer>
                        {/*<LangSelect style={{ marginRight: 6 }} icon />*/}
                    </Toolbar>
                </AppBar>
                <Drawer open={anchor} onClose={() => setanchor(false)}>
                    <AuthUserContext.Consumer>{(authUser) => authUser && <AuthDrawer user={authUser} setanchor={setanchor} />}</AuthUserContext.Consumer>
                </Drawer>
            </>
        );
    }
};

export default Navigation;

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    profileAvatar: {
        height: 86,
        width: 86,
        fontSize: 64,
        marginBottom: 16,
        backgroundColor: purple[500],
        "&:hover": {
            cursor: "pointer",
        },
    },
}));
